<template>
    <div v-if="hash === ''">
        <courses-index
            :courses="courses"
            :topics="topics"
            :course-difficulty-levels="courseDifficultyLevels"
            :per-page="perPage"
            :filtered-courses="indexFilteredCourses"
            :current-page="indexCurrentPage"
            :pages="indexPages"
            :filters="indexFilters"
            :search-query="indexSearchQuery">
        </courses-index>
    </div>
    <div v-else>
        <show-course
            :courses="courses"
            :course-slug="courseSlug"
            :lesson-number="lessonNumber">
        </show-course>
    </div>
</template>

<script>
import CoursesIndex from './partials/index.vue';
import ShowCourse from './partials/show.vue';

export default {
    components: {
        'courses-index': CoursesIndex,
        'show-course': ShowCourse,
    },

    props: {
        courses: {
            type: Array,
            required: true,
        },
        topics: {
            type: Array,
            required: true,
        },
        courseDifficultyLevels: {
            type: Array,
            required: true,
        },
        perPage: {
            type: Number,
            default: 4,
        },
    },

    data() {
        return {
            indexFilteredCourses: this.courses,
            indexCurrentPage: 1,
            indexPages: Math.ceil(this.courses.length / this.perPage),
            indexFilters: {
                topic: [],
            },
            indexSearchQuery: '',
            hash: window.location.hash.substr(1),
        };
    },

    created() {
        window.addEventListener('popstate', () => {
            const hash = window.location.hash.substr(1);
            this.broadcastHashChange(hash);
        });

        Bus.$on('openCourse', ({ course, lessonNumber = null }) => {
            let hash;
            if (course.lessons.length > 0) {
                hash = lessonNumber
                    ? `${course.slug}-lesson-${lessonNumber}`
                    : `${course.slug}-lesson-${course.lessons[0].lesson}`;
            } else {
                hash = course.slug;
            }
            this.setHash(hash);
        });
        Bus.$on('openAllCourses', () => this.setHash(''));

        Bus.$on('setIndexCurrentPage', ({ page }) => this.indexCurrentPage = page);
        Bus.$on('setIndexFilters', ({ filters }) => this.indexFilters = filters);
        Bus.$on('setIndexFilteredCourses', ({ filteredCourses }) => this.indexFilteredCourses = filteredCourses);
        Bus.$on('setIndexSearchQuery', ({ searchQuery }) => this.indexSearchQuery = searchQuery);
    },

    watch: {
        indexFilteredCourses: function(value) {
            this.indexPages = Math.ceil(value.length / this.perPage);
            this.indexCurrentPage = 1;
        },

        indexFilters: {
            deep: true,
            handler() {
                Bus.$emit('shouldRefreshFilteredCourses');
            },
        },
    },

    computed: {
        courseSlug() {
            if (! this.hash) {
                return null;
            }
            let toIndex = this.hash.search('-lesson-');
            let courseSlug = toIndex !== -1 ? this.hash.slice(0, toIndex) : this.hash;

            return courseSlug;
        },

        lessonNumber() {
            if (! this.hash) {
                return null;
            }
            const lessonStartingIndex = this.hash.search('-lesson-');
            if (lessonStartingIndex === -1) {
                return null;
            }
            const fromIndex = lessonStartingIndex + '-lesson-'.length;
            let lessonNumber = this.hash.slice(fromIndex);

            return parseInt(lessonNumber);
        },
    },

    methods: {
        setHash(hash) {
            window.history.pushState(null, null, `#${hash}`);
            this.broadcastHashChange(hash);
        },

        broadcastHashChange(hash) {
            this.hash = hash;
        },
    },
};
</script>
